<div [class]="model.renderCssRoot" #contentElement>
  <sv-ng-tagbox [model]="model"></sv-ng-tagbox>
  <div *ngIf="model.isOtherSelected" [class]="model.getCommentAreaCss(true)" [question]="model" sv-ng-comment-other></div>
</div>